<script setup lang="ts">
import type { VragenSbiCodesSbiCodeDto } from '@services/vragen-public/api';

const props = withDefaults(
  defineProps<{
    options?: VragenSbiCodesSbiCodeDto[] | null | undefined;
    value?: string;
    parentIndex?: number;
    selectIndex?: number;
  }>(),
  { parentIndex: 0 },
);

const emit = defineEmits<{ (e: 'onSbiSelected', sbiOpzoek: VragenSbiCodesSbiCodeDto): void }>();

function getIndex(parentIndex: number): number {
  if (!props.options) return 0;
  const opts = props.options.slice(0, parentIndex);
  return opts.reduce((a, b) => a + (b.children?.length ?? 0), 0);
}
</script>

<template>
  <div
    :id="`option-${parentIndex + idx}`"
    data-testid="SbiOpzoek-option"
    v-for="(option, idx) in options"
    :key="option.code"
    :class="[
      'em-px-2',
      {
        'bg-primary-300': option.code === value,
      },
    ]"
  >
    <div v-if="option.children?.length" @click.stop>
      <div class="pointer-events-none em-my-2 flex font-semibold">
        <span class="em-mr-4">[{{ option.code }}]</span>
        <span>{{ option.omschrijving }}</span>
      </div>
      <SbiOpzoekOption
        :parent-index="getIndex(idx)"
        :options="option.children"
        :select-index="selectIndex"
        @onSbiSelected="(e: VragenSbiCodesSbiCodeDto) => emit('onSbiSelected', e)"
      />
    </div>
    <button
      v-else
      :aria-selected="option.code === props.value"
      :class="[
        'flex w-full cursor-pointer em-p-2 text-[.8em]',
        'hover:bg-primary hover:text-white',
        {
          'bg-primary text-white': parentIndex + idx === selectIndex,
        },
      ]"
      role="option"
      type="button"
      @click.stop="emit('onSbiSelected', option)"
    >
      <span class="em-mr-4">{{ option.code }}</span>
      <span>{{ option.omschrijving }}</span>
    </button>
  </div>
</template>
